// MediaStream is a native browser API, no import needed

/**
 * Checks if a stream reference is active
 */
export function hasActiveStream(
  streamRef: React.MutableRefObject<MediaStream | null> | null,
  streamState: MediaStream | null
): boolean {
  return !!(
    streamRef?.current?.active ||
    (streamState?.active && streamState.getVideoTracks().some(t => t.readyState === 'live'))
  );
}

/**
 * Creates media stream constraints for device switching
 */
export interface DeviceSwitchConstraints {
  video: boolean | MediaTrackConstraints;
  audio: boolean | MediaTrackConstraints;
}

export function createDeviceSwitchConstraints(
  deviceType: 'video' | 'audioInput',
  deviceId: string,
  currentVideoDevice: string | undefined,
  currentAudioDevice: string | undefined,
  mediaState: { video: boolean; audio: boolean }
): DeviceSwitchConstraints {
  return {
    video: mediaState.video
      ? deviceType === 'video'
        ? {
            deviceId: { exact: deviceId },
            width: { min: 640, ideal: 1280 },
            height: { min: 480, ideal: 720 },
            frameRate: { min: 15, ideal: 30 }
          }
        : {
            deviceId: currentVideoDevice ? { exact: currentVideoDevice } : undefined,
            width: { min: 640, ideal: 1280 },
            height: { min: 480, ideal: 720 },
            frameRate: { min: 15, ideal: 30 }
          }
      : false,
    audio: mediaState.audio
      ? deviceType === 'audioInput'
        ? {
            deviceId: { exact: deviceId }
          }
        : {
            deviceId: currentAudioDevice ? { exact: currentAudioDevice } : undefined
          }
      : false
  };
}

/**
 * Creates constraints for initial stream creation
 */
export function createInitialStreamConstraints(
  videoDeviceId?: string,
  audioDeviceId?: string
): MediaStreamConstraints {
  return {
    video: {
      deviceId: videoDeviceId ? { exact: videoDeviceId } : undefined,
      width: { min: 640, ideal: 1280 },
      height: { min: 480, ideal: 720 },
      frameRate: { min: 15, ideal: 30 }
    },
    audio: audioDeviceId
      ? {
          deviceId: { exact: audioDeviceId }
        }
      : true
  };
}

